module.exports = __webpack_public_path__ + "img/gears-icon.fcd9470c.svg";